import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import { DateTime } from 'luxon';

export type SaveInstallationsFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveInstallationsFormProps) => {
  const [
    fnSaveInstallationsForm,
    { loading }
  ] = ds.useSaveInstallations();



  const form = ds.useFormState(props.id);
  const handleSubmit = async (data: ds.IFormState) => {

    await fnSaveInstallationsForm({
      decisionDueDate: DateTime.fromFormat(data.decisionDueDate, 'yyyy-LL-dd'),
      installationIds: data.installationIds ?? []
    });
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <StyledTextField.FC
        {...form.genFieldProps('decisionDueDate')}
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
